import { useCallback, useRef } from 'react';

/**
 * Throttle hook. Ensures a function is called at most once every `timeout` milliseconds.
 */
export const useThrottle = <T extends (...args: any[]) => any>(func: T, timeout: number) => {
  const isThrottled = useRef(false);
  return useCallback(
    (...args: Parameters<T>) => {
      if (isThrottled.current) return;
      isThrottled.current = true;
      func(...args);
      setTimeout(() => (isThrottled.current = false), timeout);
    },
    [func, timeout]
  );
};
